import { render } from "./ResizableTextArea.vue?vue&type=template&id=bb5d1f3a"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__